import { CommonSettings } from '../interfaces';
import { useSettingsStore } from './useSettingsStore';

/**
 * Custom hook to get the Axios instance from the settings store.
 *
 * This hook uses the `useSettingsStore` hook to access the global settings state,
 * and then retrieves the Axios instance from the settings.
 *
 * @returns {AxiosInstance} The Axios instance from the settings.
 *
 * Example usage:
 *
 * const axiosInstance = useAxiosInstance();
 * axiosInstance.get('/api/data')
 *   .then(response => {
 *     return response.data;
 *   })
 *   .catch(error => {
 *     return error;
 *   });
 */
export function useAxiosInstance() {
  // Access the state from the settings store using the custom hook `useSettingsStore`
  const { state } = useSettingsStore();

  // Extract the settings from the state and type it as `CommonSettings`
  const settings: CommonSettings = state.settings;

  // Return the Axios instance from the settings
  return settings.axiosInstance;
}
